// src/components/RecommendationPanel/RecommendationPanel.jsx
import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import "./RecommendationPanel.css";

const RecommendationPanel = ({
  location = "Montreal",
  onLocationSelect,
  onAddToFavorites,
  onAddToMyTrip,
  favorites = [],
}) => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  // 模拟数据 - 使用可靠的图片源
  const mockRecommendations = {
    "For you in Montreal": [
      {
        id: "mt-royal",
        name: "Mount Royal Park",
        category: "Nature & Parks",
        image:
          "https://www.seesight-tours.com/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fsee-sight-tours%2Fimage%2Fupload%2Fv1745483291%2Fstrapi%2FMontreal_Mount_Royal_Canada_2c536106d5.jpg&w=3840&q=100",
        type: "Attraction",
        rating: 4.5,
        reviews: 2847,
        description: "Iconic park with hiking trails and city views",
        lat: 45.5088,
        lng: -73.5878,
      },
      {
        id: "old-montreal",
        name: "Old Montreal",
        category: "Historic Sites",
        image:
          "https://www.seesight-tours.com/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fsee-sight-tours%2Fimage%2Fupload%2Fv1745825064%2Fstrapi%2FOld_Montreal_72ac1a765a.jpg&w=3840&q=100",
        type: "Attraction",
        rating: 4.6,
        reviews: 5234,
        description: "Charming cobblestone streets and historic architecture",
        lat: 45.5088,
        lng: -73.5516,
      },
      {
        id: "notre-dame",
        name: "Notre-Dame Basilica",
        category: "Religious Sites",
        image:
          "https://res.cloudinary.com/see-sight-tours/image/upload/v1688993390/strapi/image3_9ada7a5edd.jpg",
        type: "Attraction",
        rating: 4.7,
        reviews: 8965,
        description: "Stunning Gothic Revival architecture",
        lat: 45.5045,
        lng: -73.5562,
      },
    ],
    "Get started": [
      {
        id: "travel-quiz",
        name: "Take our travel quiz",
        category: "Planning Tool",
        image:
          "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=400&h=300&fit=crop",
        type: "Tool",
        description:
          "Discover your travel style and get personalized recommendations",
        action: "quiz",
      },
      {
        id: "create-trip",
        name: "Create a trip",
        category: "Planning Tool",
        image:
          "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&h=300&fit=crop",
        type: "Tool",
        description: "Start planning your perfect Montreal getaway",
        action: "create",
      },
      {
        id: "creator-tools",
        name: "Creator tools",
        category: "Advanced",
        image:
          "https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=300&fit=crop",
        type: "Tool",
        description: "Advanced tools for travel content creators",
        action: "tools",
      },
    ],
    "Get inspired": [
      {
        id: "restaurant-gems",
        name: "Restaurant gems in Montreal",
        category: "Food & Dining",
        image:
          "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=300&fit=crop",
        type: "Guide",
        rating: 4.8,
        description: "Hidden culinary treasures in the city",
        count: "12 spots",
      },
      {
        id: "scenic-wonders",
        name: "Scenic Wonders of Montreal",
        category: "Photography",
        image:
          "https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?w=400&h=300&fit=crop",
        type: "Guide",
        rating: 4.6,
        description: "Most Instagram-worthy spots in the city",
        count: "8 locations",
      },
      {
        id: "must-try-food",
        name: "Top 5 must-try French foods",
        category: "Food Culture",
        image:
          "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=400&h=300&fit=crop",
        type: "Guide",
        rating: 4.9,
        description: "Essential French-Canadian cuisine experiences",
        count: "5 dishes",
      },
    ],
    "Local favorites": [
      {
        id: "bagel-shops",
        name: "Authentic Montreal bagels",
        category: "Local Food",
        image:
          "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=400&h=300&fit=crop",
        type: "Local",
        rating: 4.9,
        description: "Where locals get their fresh bagels",
        count: "6 shops",
      },
      {
        id: "poutine-spots",
        name: "Best poutine in the city",
        category: "Local Food",
        image:
          "https://images.unsplash.com/photo-1630409414744-a5652b66f0b8?w=400&h=300&fit=crop",
        type: "Local",
        rating: 4.7,
        description: "Authentic Quebec poutine experiences",
        count: "8 restaurants",
      },
      {
        id: "local-markets",
        name: "Farmers markets & local goods",
        category: "Shopping",
        image:
          "https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=400&h=300&fit=crop",
        type: "Local",
        rating: 4.5,
        description: "Fresh produce and local artisan products",
        count: "5 markets",
      },
    ],
  };

  useEffect(() => {
    // 模拟API调用
    setLoading(true);
    setTimeout(() => {
      setSections(
        Object.entries(mockRecommendations).map(([title, items]) => ({
          title,
          items,
        }))
      );
      setLoading(false);
    }, 500);
  }, [location]);

  const handleCardClick = (item) => {
    if (item.action) {
      // 处理工具类操作
      switch (item.action) {
        case "quiz":
          console.log("启动旅行测试");
          break;
        case "create":
          console.log("创建新行程");
          if (onLocationSelect) {
            onLocationSelect(item);
          }
          break;
        case "tools":
          console.log("打开创作者工具");
          break;
        default:
          break;
      }
    } else if (item.lat && item.lng) {
      // 处理地点选择
      if (onLocationSelect) {
        onLocationSelect(item);
      }
    }
  };

  if (loading) {
    return (
      <div className="recommendation-panel">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading recommendations...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="recommendation-panel">
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="recommendation-section">
          <div className="section-header">
            <h3 className="section-title">{section.title}</h3>
            {section.title === "Get inspired" && (
              <button className="see-all-btn">See all</button>
            )}
          </div>

          <div className="cards-grid">
            {section.items.map((item, itemIndex) => (
              <Card
                key={item.id}
                className="recommendation-card"
                onClick={() => handleCardClick(item)}
              >
                <div className="card-image-overlay">
                  <Card.Img
                    variant="top"
                    src={item.image}
                    className="card-image"
                    onError={(e) => {
                      if (!e.target.dataset.errorHandled) {
                        e.target.dataset.errorHandled = "true";
                        e.target.src = "https://picsum.photos/400/300";
                      }
                    }}
                  />

                  {/* 白色文字覆盖层 */}
                  <div className="card-text-overlay">
                    <h4 className="card-title-overlay">{item.name}</h4>
                    {item.description && (
                      <p className="card-description-overlay">
                        {item.description}
                      </p>
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecommendationPanel;
